export enum EntityType {
  Portfolio = 'portfolio',
  Project = 'project',
  Subproject = 'subproject',
  Task = 'task',
  Sprint = 'sprint',
  Team = 'team',
}
